import { FC, useContext } from "react";

import * as cols from "components/ListingTable/setupColumns";
import { EMPTY_VALUE_PLACEHOLDER } from "constants/index";
import { BaseListings } from "containers";
import { AppContext } from "contexts";
import * as routes from "routes";
import { useAppConfigs } from "services/appConfigs";

import {
  makeDefaultUiParams,
  validDynamicRestUrlParams,
  validUiSortOptions,
} from "./filters/constants";
import { buildFilters } from "./filters";

const PastDeals: FC = () => {
  const appConfigsHeaderStats = useAppConfigs(["COMPLETED_TRANSACTIONS_COUNT"]);
  const { user } = useContext(AppContext);
  const userId = user?.userId;

  return (
    <BaseListings
      buildFilters={buildFilters}
      makeDefaultUiParams={makeDefaultUiParams}
      validDynamicRestUrlParams={validDynamicRestUrlParams}
      validUiSortOptions={validUiSortOptions}
      desktopColumns={
        !!userId ? cols.desktopPastDeals : cols.desktopPastDealsAnonymous
      }
      mobileColumns={cols.mobilePastDeals}
      headerContent={{
        h1Content: { default: "The Exchange", xsDown: "Past Deals" },
        subtitle1Content: `Access to uncorrelated, royalty-generating intellectual property. More than ${
          appConfigsHeaderStats.data?.COMPLETED_TRANSACTIONS_COUNT ||
          EMPTY_VALUE_PLACEHOLDER
        } deals completed on Royalty Exchange and new assets added each week.`,
        headerButtonContent: {
          label: !!userId ? "Open Listings" : "Join Now",
          path: !!userId
            ? routes.orderBookOpenListings(userId)
            : routes.directorySignUp(),
        },
      }}
      title="Past Deals"
      baseUrl={routes.orderBookPastDealsNoParams()}
      hideUserNotificationTags={["filled", "filled_for_user"]}
    />
  );
};

export default PastDeals;
